import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWideHalfAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconColumnWideHalfAdd"><Path d="M12.5 19.5H2.5V12M2.5 12V4.5H21.5V12H2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 16.5V19.5M19.5 19.5V22.5M19.5 19.5H16.5M19.5 19.5H22.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconColumnWideHalfAdd;
